import { render } from "./sendOffer.vue?vue&type=template&id=2f936950"
import script from "./sendOffer.vue?vue&type=script&lang=js"
export * from "./sendOffer.vue?vue&type=script&lang=js"
script.render = render

export default script